import { defineComponent as p, computed as a, createBlock as m, openBlock as l, resolveDynamicComponent as s, mergeProps as d, withCtx as u, withDirectives as f, createVNode as i, unref as t, vShow as c } from "vue";
import "./vue3-lottie.es-BQlzj7s3.js";
import "./style-R_nxVIjQ.js";
import { _ as y } from "./UiIcon.vue_vue_type_script_setup_true_lang-BEUNoCyM.js";
/* empty css                                                */
/* empty css                                                         */
/* empty css                                                    */
import "./useDatePicker-DAFR8Jnp.js";
import "../config/index.js";
/* empty css                                                           */
/* empty css                                                       */
/* empty css                                                   */
/* empty css                                                  */
/* empty css                                                    */
/* empty css                                                    */
/* empty css                                                    */
/* empty css                                                  */
/* empty css                                                      */
import "vue-router";
/* empty css                                                */
import { _ as z } from "./UiLoading.vue_vue_type_script_setup_true_lang-CrLaqUzi.js";
/* empty css                                                 */
/* empty css                                                      */
/* empty css                                                        */
/* empty css                                                    */
/* empty css                                                */
/* empty css                                                    */
/* empty css                                                               */
/* empty css                                                    */
const R = /* @__PURE__ */ p({
  __name: "UiIconButton",
  props: {
    mode: { default: "circle" },
    type: { default: "clear" },
    size: { default: "md" },
    iconName: { default: "home" },
    iconType: { default: "400" },
    iconColor: {},
    disabled: { type: Boolean },
    loading: { type: Boolean, default: !1 },
    noSize: { type: Boolean, default: !1 },
    to: { default: "" },
    href: { default: "" },
    nativeType: { default: "button" }
  },
  setup(r) {
    const e = r, n = a(() => e.href ? "a" : e.to ? "router-link" : "button");
    return (o, h) => (l(), m(s(n.value), d(o.$attrs, {
      to: o.to,
      type: o.nativeType,
      disabled: o.disabled || o.loading,
      class: ["ui-icon-button", [
        `size-${o.size}`,
        `type-${o.type}`,
        `mode-${o.mode}`,
        {
          "is-loading": o.loading,
          "is-no-size": o.noSize
        }
      ]]
    }), {
      default: u(() => [
        f(i(t(y), {
          color: o.iconColor,
          name: o.iconName,
          type: o.iconType,
          size: o.size
        }, null, 8, ["color", "name", "type", "size"]), [
          [c, !o.loading]
        ]),
        i(t(z), {
          "is-show": o.loading,
          "icon-size": o.size,
          "icon-color": o.iconColor
        }, null, 8, ["is-show", "icon-size", "icon-color"])
      ]),
      _: 1
    }, 16, ["to", "type", "disabled", "class"]));
  }
});
export {
  R as _
};
